// src/redux/slices/authApiSlice.ts

import { createSlice } from "@reduxjs/toolkit";

interface AuthState {
  isAuthenticated: boolean;
  isAuthLoading: boolean;
}

const initialState: AuthState = {
  isAuthenticated: false,
  isAuthLoading: true,
};

const authApiSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {
    startAuthLoading: (state) => {
      state.isAuthLoading = true;
    },

    setAuth: (state) => {
      state.isAuthenticated = true;
      state.isAuthLoading = false;
    },

    setLogout: (state) => {
      state.isAuthenticated = false;
      state.isAuthLoading = false;
    },
  },
});

export const {
  startAuthLoading,
  setAuth,
  setLogout,
} = authApiSlice.actions;

export default authApiSlice.reducer;